import { Field, FieldLabel } from "@components/ui/field";
import {
  InputGroup,
  InputGroupTextarea,
  InputGroupAddon,
  InputGroupButton,
} from "@components/ui/input-group";
import {
  Item,
  ItemMedia,
  ItemContent,
  ItemTitle,
  ItemDescription,
} from "@components/ui/item";
import { useLingui, Trans } from "@lingui/react/macro";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "@components/ui/popover";
import { LightbulbIcon } from "lucide-react";
import { useState } from "react";
import { PopoverClose } from "@radix-ui/react-popover";

type OtherUseCaseProps = {
  onAdd: (description: string) => void;
  onClear: () => void;
  isActive: boolean;
};

export default function OtherUseCase({
  isActive,
  onAdd,
  onClear,
}: OtherUseCaseProps) {
  const { t } = useLingui();
  const [description, setDescription] = useState("");

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Item
          className="text-left data-[active=true]:border-violet-500 data-[active=true]:bg-violet-50 group/other-use-case"
          data-active={isActive}
          variant="outline"
          asChild
        >
          <button type="button">
            <ItemMedia
              variant="icon"
              className="group-data-[active=true]/other-use-case:bg-violet-600 group-data-[active=true]/other-use-case:border-violet-600 group-data-[active=true]/other-use-case:text-white"
            >
              <LightbulbIcon />
            </ItemMedia>
            <ItemContent className="gap-0.5">
              <ItemTitle>
                <Trans>Annat</Trans>
              </ItemTitle>
              <ItemDescription>
                <Trans>Beräta mer</Trans>&nbsp;&rarr;
              </ItemDescription>
            </ItemContent>
          </button>
        </Item>
      </PopoverTrigger>

      <PopoverContent className="w-(--radix-popover-trigger-width)">
        <Field>
          <FieldLabel htmlFor="other-use-case-description">
            <Trans>Användningsområde</Trans>
          </FieldLabel>

          <InputGroup>
            <InputGroupTextarea
              rows={5}
              autoFocus
              value={description}
              id="other-use-case-description"
              onChange={(e) => setDescription(e.target.value)}
              placeholder={t`Jag vill använda All Ears för att...`}
            />
            <InputGroupAddon align="block-end" className="justify-end">
              <PopoverClose asChild>
                <InputGroupButton variant="secondary">
                  <Trans>Avbryt</Trans>
                </InputGroupButton>
              </PopoverClose>

              <PopoverClose
                asChild
                onClick={() => {
                  if (description) {
                    onAdd(description);
                  } else {
                    onClear();
                  }
                }}
              >
                <InputGroupButton type="button" variant="default">
                  <Trans>Klar</Trans>
                </InputGroupButton>
              </PopoverClose>
            </InputGroupAddon>
          </InputGroup>
        </Field>
      </PopoverContent>
    </Popover>
  );
}
